<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <div class="flex-row center-baseline gap-8">
      <div class="person-name" uiTruncateText>{{ nameControl.value }}</div>
      <span class="recognitions"
        >{{ data?.personDetails?.appearance }} {{ 'PEOPLE_UNSAVED_LIST.RECOGNITIONS' | translate }}</span
      >
    </div>
    <span class="ui-icon-close c-p" mat-dialog-close></span>
  </div>
  <div class="body flex-col gap-24">
    <div class="profile-card flex-col gap-16">
      <div class="avatar-container p-r">
        <img
          [appAuthSrc]="img()"
          [appAuthSrcFallback]="img(false)"
          [defaultImage]="defaultPersonImage"
          alt="Profile avatar"
        />
      </div>

      <div class="flex-col gap-8 input-field p-r">
        <div>{{ 'PEOPLE.PROFILE_NAME' | translate }}</div>
        <input
          class="ui-input"
          type="text"
          tabindex="-1"
          [readonly]="!isEditing()"
          [ngClass]="{ readonly: !isEditing() }"
          [formControl]="nameControl"
        />
        @if (!isEditing()) {
        <span
          [matTooltip]="'PEOPLE.TOOLTIPS.EDIT' | translate"
          matTooltipClass="sidebar-tooltip"
          class="ui-icon-edit c-p icons" (click)="onEdit(true)"></span>
        } @else {
        <div class="flex-row gap-16 icons">
          <span
            [matTooltip]="'VEHICLES.TOOLTIPS.CANCEL' | translate"
            matTooltipClass="sidebar-tooltip"
            class="ui-icon-close c-p" (click)="onCancel()"></span>
          <span
            [matTooltip]="'PEOPLE.TOOLTIPS.SAVE' | translate"
            matTooltipClass="sidebar-tooltip"
            class="ui-icon-save c-p" (click)="onSave()"></span>
        </div>
        }
      </div>

      <div *ngIf="data?.cameraName && data?.locationName" class="flex-row space-between-center">
        <div class="flex-col gap-6 center-center info-item">
          <span class="ui-icon-camera ui-icon-20"></span>
          <div class="flex-col text">
            <span class="info-text">{{ data.cameraName }}</span>
            <span class="info-text-secondary">{{ data.locationName }}</span>
          </div>
        </div>
        <div class="divider-vertical"></div>
        <div class="flex-col gap-6 center-center info-item">
          <mat-icon svgIcon="eye"></mat-icon>
          <div class="flex-col text">
            <span class="info-text">
              {{ data?.personDetails?.timestamp | date : 'MMMM d,' }}
            </span>
            <span class="info-text-secondary">
              {{ data?.personDetails?.timestamp | date : 'h:mm a y' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer flex-row space-between-center">
    <button class="footer-remove-btn flex-row center-center" mat-button="elevated" tabindex="-1">
      @if (deleteLoader()) {
        <ui-preloader [color]="PreloaderColor.gray" [diameter]="20"></ui-preloader>
      } @else {
        <mat-icon svgIcon="delete" (click)="onRemove()"></mat-icon>
      }
    </button>
    <ui-button
      type="primary"
      [text]="'COMMON.CLOSE' | translate"
      [disabled]="isEditing()"
      (click)="onDone()"
    ></ui-button>
  </div>
</div>
